import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery } from 'react-query'
import { UserClient } from 'api/clients/UserClient'

/**
 * Returns the enabled features from the backend without applying user-specific (localStorage) or URL query param overrides.
 * @returns A react-query result containing an array of feature names
 */
export const useFeaturesWithoutUserOverrides = () =>
  useQuery(
    'featureFlags',
    async () => {
      const res = await UserClient.getFeatures()
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    // do not cache this endpoint, regardless of default values
    // because we e.g. may be in a demo situation where we want to immediately
    // respect the updated flag on the back-end after a hard refresh
    { staleTime: Infinity, cacheTime: 0 },
  )
